import app from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/database';
//import 'firebase/firestore';

const firebaseConfigDev = {
  //Production
  apiKey: "AIzaSyBXR1mXS9n2H5gADtVi4bf0QXtbvsNKdsg",
  authDomain: "hackmakers-35566.firebaseapp.com",
  databaseURL: "https://hackmakers-35566.firebaseio.com",
  projectId: "hackmakers-35566",
  storageBucket: "hackmakers-35566.appspot.com",
  messagingSenderId: "627641759060",
  appId: "1:627641759060:web:43070611dd240cd671c4c1",
  measurementId: "G-0GZR2VE051"  
  };

  /*
const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
};

.env file:
REACT_APP_API_KEY=XXXXxxxx
REACT_APP_AUTH_DOMAIN=xxxxXXXX.firebaseapp.com
REACT_APP_DATABASE_URL=https://xxxXXXX.firebaseio.com
REACT_APP_PROJECT_ID=xxxxXXXX
REACT_APP_STORAGE_BUCKET=xxxxXXXX.appspot.com
REACT_APP_MESSAGING_SENDER_ID=xxxxXXXX
  */

class Firebase {
    constructor() {
      app.initializeApp(firebaseConfigDev);
      app.analytics();

      this.auth = app.auth();
      this.db = app.database();
      //this.store = app.firestore();
    }

    
    // *** Auth API ***
 
    doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);
 
    doPasswordUpdate = password =>
      this.auth.currentUser.updatePassword(password);

    // *** User API ***

    user = uid => this.db.ref(`users/${uid}`);
    currUser = () => this.db.ref(`users/${this.auth.currentUser.uid}`);
    users = () => this.db.ref('users'); 
    progressList = (uid) => this.db.ref(`users/${uid}/progressList`);
    gettingStarted = (uid) => this.db.ref(`users/${uid}/progressList/gettingStarted`);
    formYourTeam = (uid) => this.db.ref(`users/${uid}/progressList/formYourTeam`);
    startHacking = (uid) => this.db.ref(`users/${uid}/progressList/startHacking`);
    presentSubmit = (uid) => this.db.ref(`users/${uid}/progressList/presentSubmit`);
    //user = uid => this.store.collection("users");

}
   
export default Firebase;